import { GetProspectsQueryParams } from "@/core/customers/entities/ProspectsTypes";

/** Pose la valeur seulement si elle est fournie : ni undefined/null, ni chaine vide (0 est garde). */
function setIfPresent(
  searchParams: URLSearchParams,
  key: string,
  value: string | number | null | undefined,
) {
  if (value === undefined || value === null || value === "") {
    return;
  }
  searchParams.set(key, String(value));
}

export const getProspectsUrl = (params?: GetProspectsQueryParams) => {
  const baseUrl = `/customers/prospects`;

  if (!params) {
    return baseUrl;
  }

  const searchParams = new URLSearchParams();

  setIfPresent(searchParams, "filterValue", params.filterValue);
  setIfPresent(searchParams, "customerType", params.customerType);
  // Repetable : le back lit une liste. Omis quand vide, ce qui lui fait appliquer son defaut
  // (PROSPECT seul) plutot que de recevoir un filtre vide a interpreter.
  params.status?.forEach((status) => searchParams.append("status", status));
  setIfPresent(searchParams, "channel", params.channel);
  setIfPresent(searchParams, "createdFrom", params.createdFrom);
  setIfPresent(searchParams, "createdTo", params.createdTo);
  setIfPresent(searchParams, "offset", params.offset);
  setIfPresent(searchParams, "rows", params.rows);
  setIfPresent(searchParams, "sortBy", params.sortBy);
  setIfPresent(searchParams, "sortDirection", params.sortDirection);

  const queryString = searchParams.toString();

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
export const getProspectsLocalUrl = () => `/customers/prospect-list`;

// GET prospect details by id
export const getProspectUrl = (id: string) => `/customers/prospect/${id}`;
export const updateIdentityInfosUrl = (businessKey: string) =>
  `/customers/prospect/${businessKey}`;

// PATCH submit onboarding (no body)
export const submitProspectOnboardingUrl = (businessKey: string) =>
  `/customers/${businessKey}`;

// POST generate credentials
export const generateProspectCredentialsUrl = () => `/prospects/credentials`;

// POST revoke prospect credentials
export const revokeProspectCredentialsUrl = (businessKey: string) =>
  `/prospects/credentials/${businessKey}/revoke`;
